import React from 'react';
import { BOOKING_HREF, handleBookingClick, isBookingHref } from '../../utils/bookingNavigation';
import './Footer.css';

const navLinks = [
  { label: 'Home', href: '/' },
  { label: 'Services', href: '/#services' },
  { label: 'About Us', href: '/about' },
  { label: 'Contact', href: BOOKING_HREF },
];

const Footer = () => (
  <footer className="footer">
    <div className="footer__inner">
      <div className="footer__brand">
        <span className="footer__name">Fresh Start</span>
        <span className="footer__subtitle">Landscaping &amp; Maintenance</span>
        <p className="footer__tagline">Together, we bring your vision to life.</p>
      </div>
      <div className="footer__col">
        <span className="footer__col-heading">Navigate</span>
        <nav className="footer__links">
          {navLinks.map(link => (
            <a
              key={link.label}
              href={link.href}
              className="footer__link"
              onClick={isBookingHref(link.href) ? handleBookingClick : undefined}
            >
              {link.label}
            </a>
          ))}
        </nav>
      </div>
      <div className="footer__col">
        <span className="footer__col-heading">Get in Touch</span>
        <div className="footer__contact">
          <div className="footer__contact-item"><span className="footer__contact-icon">📞</span><span>970-631-5060</span></div>
          <div className="footer__contact-item"><span className="footer__contact-icon">✉</span><span>hello@freshstartscapes.com</span></div>
          <div className="footer__contact-item"><span className="footer__contact-icon">📍</span><span>Western Colorado</span></div>
        </div>
      </div>
    </div>
    <div className="footer__bottom">
      <div className="footer__bottom-inner">
        <p>© 2026 Fresh Start Landscapes, LLC. All Rights Reserved.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
